import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logAudit } from '../../utils/logAudit';

export const ComponentAlerts = ({ alertType, alertMessageKey, rawMessage }) => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [lastAuditKey, setLastAuditKey] = useState(null);
    useEffect(() => {
        if (alertType && (alertMessageKey || rawMessage)) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    }, [alertType, alertMessageKey, rawMessage]);

    useEffect(() => {
      if (!isVisible) return;
        const key = `${alertType}::${alertMessageKey || rawMessage || ''}`;
        if (key === lastAuditKey) return;
        setLastAuditKey(key);
        try {
            const stateMap = { info: 'INFO', warning: 'WARN', error: 'ERROR' };
            const baseState = stateMap[alertType] || 'INFO';

            const auditPayload = {
                state: baseState,
                event: 'UI_ALERT_SHOWN',
                args: {
                    alertType,
                    alertMessageKey: t(alertMessageKey) || null,
                    rawMessage: rawMessage ? true : false
                }
            };

            if (alertType === 'error') {
                // SAFETY: en caso de error, mandamos el detalle real en "error"
                auditPayload.error = t(alertMessageKey) || rawMessage || 'Unknown error';
            } else {
                auditPayload.message = t(alertMessageKey) || rawMessage || 'UI alert displayed';
            }

            logAudit(auditPayload);
        } catch {}
    }, [isVisible, alertType, alertMessageKey, rawMessage, lastAuditKey]);

    if (!isVisible) return null;

    const alertClasses = {
        success: 'alert alert-success',
        warning: 'alert alert-warning',
        error: 'alert alert-error'
    };

    const iconClasses = {
        success: 'check_circle',
        warning: 'warning',
        error: 'cancel'
    };

    const content = rawMessage || t(alertMessageKey);
    return (
        <div className="component-alert">
            <div className={alertClasses[alertType]}>
                <span className="material-icons">{iconClasses[alertType]}</span>
                <p>{content}</p>
            </div>
        </div>
    );
};
